var cache = new Map();
export default cache;
//# sourceMappingURL=cache.js.map